import { Link } from '@tanstack/react-router'

import { Button } from '@/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/card'

interface Props {
    title: string
    errorMessage: string
}

export default function InviteError({ title, errorMessage }: Props) {
    return (
        <Card className="absolute-center w-96">
            <CardHeader>
                <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardContent>
                <CardDescription className="mb-4">{errorMessage}</CardDescription>
                <Link to={'/'}>
                    <Button className="mt-4">Go back</Button>
                </Link>
            </CardContent>
        </Card>
    )
}
